import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  CardBody,
  UncontrolledPopover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  FormFeedback,
  ModalFooter,
  Form,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  ButtonGroup,
} from "reactstrap"
import {
  fetchProjectDashboard,
  fetchStoreCsRequest,
  fetchStoreDashRequest,
  fetchStoreGraph,
  fetchStoreIssueNote,
  fetchStoreMaterialRequest,
  postAttendance,
  postCentralRequest,
  postIssueNote,
  postRequestManpower,
} from "../../../../services/projectManager/projectMaster"
import { useNavigate, useParams } from "react-router-dom"
import UpdateTable from "../../../../components/Common/UpdatedTable"
import TimeLineDD from "../../../../components/Common/chooseFields/TimeLineDD"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import action from "../../../../assets/icons/action.svg"
import closeIcon from "../../../../assets/icons/close.svg"
import requestIcon from "../../../../assets/icons/request.svg"
import Chart from "react-apexcharts"
import { isEmpty, noConflict } from "lodash"
import {
  UFDate,
  UFEditor,
  UFInput,
  UFInputDashboard,
  UFTime,
} from "../../../../components/Common/Fields/Input"
import LoadingButton from "../../../../components/Common/LoadingButton"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import UsersList from "../../../../components/Common/chooseFields/userList"
import { toastError, toastSuccess } from "../../../../helpers/msg_helper"
import moment from "moment"
import EditMaterialRequest from "../../../Procurement/materialrequest/edit"
import {
  searchHrmsTimeSheet,
  searchHrmsTimeSheetUpdate,
} from "../../../../services/Hrms/hrms"
import NumberFormat from "../../../../utils/numberFormat"
import TasksList from "../../../../components/Common/chooseFields/tasksList"
import EmployeeList from "../../../../components/Common/chooseFields/employee"
import LeaveType from "../../../../components/Common/chooseFields/leaveType"
import ShiftsList from "../../../../components/Common/chooseFields/shiftsLi"
// import ShopKeeperFilter from "./filter"

const TimeKeeper = () => {
  document.title = "Store Keeper Dashboard | Ever Rise"

  const { id } = useParams()
  const navigate = useNavigate()

  //refresh state
  const [refresh, setRefresh] = useState(0)
  const [refresh1, setRefresh1] = useState(0)
  const [refresh2, setRefresh2] = useState(0)
  const [refresh3, setRefresh3] = useState(0)
  const [refresh4, setRefresh4] = useState(0)
  const [refreshAdd, setRefreshAdd] = useState(0)
  const [refreshChart, setRefreshChart] = useState(0)

  //pagination state
  const [page, setPage] = useState("")
  const [materialPage, setMaterialRequestPage] = useState("")
  const [csRequestPage, setCsRequestPage] = useState("")
  const [issueNotePage, setIssueNotePage] = useState("")

  //view and model chart
  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  //response state
  const [materialData, setMaterialData] = useState()
  const [materialRequestData, setMaterialRequestData] = useState()
  const [csRequestData, setCsRequestData] = useState()
  const [issueNoteData, setIssueNoteData] = useState()
  const [storeDashData, setStoreDashData] = useState()
  const [graphData, setGraphData] = useState()
  const [activeTab, setActiveTab] = useState("1")
  const [dateRange, setDateRange] = useState({})
  const [employeeId, setEmployeeid] = useState("")

  const [search, setSearch] = useState("")
  const [search1, setSearch1] = useState("")

  const [rSelected, setRSelected] = useState([])
  const [newRSelected, setNewRSelected] = useState(1)
  const [dateSelected, setDateStelected] = useState(
    moment().format("YYYY-MM-DD")
  )

  const schema1 = yup.object().shape({
    ...(viewData?.id === 4 && {
      project_quantity: yup
        .number()
        .min(1, "Quantity must be 1 or more")
        .max(
          Number(viewData?.value),
          `Quantity must be ${viewData?.value} or less`
        )
        .typeError("Quantity Must be Number")
        .required("Quantity is Required"),
      contact_person: yup.mixed().required("Contact Person is Required"),
      issue_date: yup.string().required("Issue Date is Required"),
    }),
    ...(viewData?.id === 5 && {
      central_quantity: yup
        .number()
        .min(1, "Quantity must be 1 or more")
        .max(
          Number(viewData?.value),
          `Quantity must be ${viewData?.value} or less`
        )
        .typeError(" Quantity Must be Number")
        .required(" Quantity is Required"),
      description: yup.string().required("Description is Required"),
    }),
    ...(viewData?.id === 7 && {
      req_manpower_no: yup
        .number()
        .min(1, "Number of Hours must be 1 or more")
        .max(
          Number(viewData?.req_manpower_no) -
            Number(
              viewData?.value?.manpower_requests_sum_req_manpower_no
                ? viewData?.value?.manpower_requests_sum_req_manpower_no
                : 0
            ),
          `Number of Hours must be ${
            Number(viewData?.req_manpower_no) -
            Number(
              viewData?.value?.manpower_requests_sum_req_manpower_no
                ? viewData?.value?.manpower_requests_sum_req_manpower_no
                : 0
            )
          } or less`
        )
        .typeError(" Number of Hours Must be Number")
        .required(" Number of Hours is Required"),
      req_remarks: yup.string().required("Remarks is Required"),
      request_date: yup.mixed().required("Date is Required"),
      exp_qty: yup
        .number()
        .min(1, "Expected Quantity must be 1 or more")
        .typeError("Expected Quantity must be Number"),
    }),
  })

  const {
    control,
    handleSubmit: handleSubmit1,
    getValues: getValues1,
    setValue: setValue1,
    reset: reset1,
    watch: watch1,
    formState: { errors: errors1 },
  } = useForm({
    resolver: yupResolver(schema1),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      date_search: moment().format("YYYY-MM-DD"),
      attendance: [
        {
          overtime: 0,
        },
      ],
    },
  })

  const {
    fields: attendanceFields,
    append: attendanceAppend,
    remove: attendanceRemove,
  } = useFieldArray({
    control,
    name: "attendance_new",
    // focusAppend: false,
  })
  console.log(`attendanceFields`, attendanceFields)

  useEffect(() => {
    if (activeTab == 1 && materialData?.data?.data) {
      setRSelected(Array(materialData.data.data.length).fill(1))
      const attendanceArr = materialData?.data?.data?.map((dt, i) => ({
        employee_id: { value: dt?.id, label: dt?.employee_code },
        project_id: id,
        task_id: null,
        start_time: moment(`${dateSelected} 10:00`, "YYYY-MM-DD HH:mm").format(
          "YYYY-MM-DD HH:mm"
        ),
        end_time: moment(`${dateSelected} 18:00`, "YYYY-MM-DD HH:mm").format(
          "YYYY-MM-DD HH:mm"
        ),
        overtime: 0,
        status: 1,
      }))

      reset1({ attendance: attendanceArr })
    }
    if (activeTab == 2 && materialData?.data?.data) {
      const attendanceArr = materialData?.data?.data?.map((dt, i) => ({
        start_time: moment(dt?.start_time, "YYYY-MM-DD HH:mm:ss").format(
          "HH:mm"
        ),
        end_time: moment(dt?.end_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm"),
        overtime: dt?.overtime,
        shift_id: { label: dt?.shift?.name, value: dt?.shift?.id },
        task_id: { label: dt?.task?.name, value: dt?.task?.id },
      }))

      const presentValues = materialData.data.data.map((dt, i) =>
        dt?.present == 1 ? 1 : 0
      )

      setRSelected(presentValues)

      reset1({ attendance_update: attendanceArr })

      console.log(`attendanceArr`, attendanceArr, rSelected)
    }
  }, [materialData])

  console.log(viewData, `viewData`)
  const toggle = () => {
    setModal(!modal)
    const controlValue = getValues1()

    reset1({
      ...controlValue,
      project_quantity: "",
      issue_date: "",
      // filter_date: "",
      contact_person: null,
      central_quantity: "",
      description: "",
      // end_date: "",
      // start_date: "",
    })
    if (!modal === false) {
      setViewData()
    }
  }
  const resetAfterCreatePo = () => {
    setModal(!modal)
    if (!modal === false) {
      setViewData()
    }
    setRefresh(refresh + 1)
    setRefresh1(refresh1 + 1)
    setRefresh4(refresh4 + 1)
  }
  const handleSearchChange = data => {
    setSearch1(data)
    setIssueNotePage(1)
    setCsRequestPage(1)
  }

  const handleView = item => {
    setViewData(item)
    toggle()
    if (item?.id == 4) {
      setValue1("project_store", item?.value)
      setValue1("product_id", item?.product_id)
    } else if (item?.id == 5) {
      setValue1("central_store", item?.value)
      setValue1("product_id", item?.product_id)
    } else if (item?.id == 7) {
      // setValue1("manpower_req", item?.product_id)
      console.log(`item`, item)
      reset1({
        category_code: item?.category_code,
        req_manpower_no:
          Number(item?.req_manpower_no) -
          Number(
            item?.value?.manpower_requests_sum_req_manpower_no
              ? item?.value?.manpower_requests_sum_req_manpower_no
              : 0
          ),
        project_manpower_id: item?.project_manpower_id,
        designation_id: item?.value?.category?.id,
        project_id: id,
      })
    }
  }

  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    setDateRange(fromDate, toDate)
  }
  console.log(`setDateRange`, dateRange)

  // const methods = useForm({
  //   resolver: yupResolver(schema1),
  //   mode: "onChange",
  //   shouldFocusError: true,
  //   defaultValues: {
  //     date_search: moment().format("YYYY-MM-DD"),
  //   },
  // })
  console.log(`date_search`, watch1("date_search"))
  useEffect(() => {
    setValue1("Time_1", { label: "Weekly", value: "thisweek" })
    setValue1("Time_2", { label: "Weekly", value: "thisweek" })
    setValue1("Time_3", { label: "Weekly", value: "thisweek" })
    setValue1("Time_chart", { label: "Weekly", value: "thisweek" })
    // setValue1("date", moment())
  }, [])

  useEffect(() => {
    const fetchClass = async () => {
      const chkApiCall =
        activeTab == 1 ? searchHrmsTimeSheet : searchHrmsTimeSheetUpdate
      const response = await chkApiCall({
        params: `${search ? `&searchText=${search}` : "&searchText"}${
          id ? `&project_id=${id}` : ""
        }${page ? `&page=${page}` : ""}${
          activeTab ? `&type=${activeTab == 1 ? 0 : 1}` : ""
        }${dateSelected && `&year_month=${dateSelected}`}`,
      })
      setMaterialData(response)
    }
    if (id) {
      fetchClass()
    }
  }, [refresh, id, activeTab, page, search, dateSelected, refreshAdd])

  const materialRequestColumns = [
    {
      label: "MR No",
      renderCell: item => item?.material_requests_code,
    },

    {
      label: "Request Date",
      renderCell: item => item?.request_date,
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.requests_sum_quantity))}
        </div>
      ),
    },
  ]
  const csRequestColumns = [
    {
      label: "Product No",
      renderCell: item => item?.product_id?.product_code,
    },

    {
      label: "Date",
      renderCell: item => moment(item?.created_at).format("YYYY-MM-DD"),
    },
    {
      label: "Staff Name",
      renderCell: item => item?.request_id?.requested_from?.name,
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.quantity))}
        </div>
      ),
    },
  ]
  const issueNoteColumns = [
    {
      label: "Product No",
      renderCell: item => item?.product_id?.product_code,
    },

    {
      label: "Date",
      renderCell: item => item?.issue_date,
    },
    {
      label: "Staff Name",
      renderCell: item => item?.contactperson?.name,
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.quantity))}
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }
  const handleMaterialRequestPaginate = page => {
    setMaterialRequestPage(page)
  }
  const handleCsRequestPaginate = page => {
    setCsRequestPage(page)
  }
  const handleissueNotePaginate = page => {
    setIssueNotePage(page)
  }

  // const mainCard = [
  //   {
  //     id: 1,
  //     name: "Total Material Request",
  //     dropdown: true,
  //     subName:
  //       watch1("Time_1")?.value == "today"
  //         ? "Last 24 Hours"
  //         : watch1("Time_1")?.value == "thisweek"
  //         ? "Last 7 days"
  //         : watch1("Time_1")?.value == "thismonth"
  //         ? "Last 30 days"
  //         : watch1("Time_1")?.value == "thisyear"
  //         ? "Last 365 days"
  //         : "",
  //     value: materialRequestData?.totalItems,
  //     viewAll: true,
  //   },
  //   {
  //     id: 2,
  //     name: "Total CS Request",
  //     dropdown: true,
  //     subName:
  //       watch1("Time_2")?.value == "today"
  //         ? "Last 24 Hours"
  //         : watch1("Time_2")?.value == "thisweek"
  //         ? "Last 7 days"
  //         : watch1("Time_2")?.value == "thismonth"
  //         ? "Last 30 days"
  //         : watch1("Time_2")?.value == "thisyear"
  //         ? "Last 365 days"
  //         : "",
  //     value: csRequestData?.totalItems,
  //     viewAll: true,
  //   },
  //   {
  //     id: 3,
  //     name: "Total Issue Note",
  //     dropdown: true,
  //     subName:
  //       watch1("Time_3")?.value == "today"
  //         ? "Last 24 Hours"
  //         : watch1("Time_3")?.value == "thisweek"
  //         ? "Last 7 days"
  //         : watch1("Time_3")?.value == "thismonth"
  //         ? "Last 30 days"
  //         : watch1("Time_3")?.value == "thisyear"
  //         ? "Last 365 days"
  //         : "",
  //     value: issueNoteData?.totalItems,
  //     viewAll: true,
  //   },
  // ]

  const handleTimeChange = (e, id) => {
    if (id == 1) {
      setMaterialRequestPage(1)
      setRefresh1(refresh1 + 1)
    } else if (id == 2) {
      setCsRequestPage(1)
      setRefresh2(refresh2 + 1)
    } else if (id == 3) {
      setIssueNotePage(1)
      setRefresh3(refresh3 + 1)
    } else if (id == "chart") {
      setRefreshChart(refreshChart + 1)
    }
  }

  const handleRegistration = async data => {
    try {
      setIsLoading(true)
      if (viewData?.id === 4) {
        const updateDepartment = await postIssueNote({
          quantity: data?.project_quantity,
          issue_date: moment(data?.issue_date).format("YYYY-MM-DD"),
          contactperson: data?.contact_person?.value,
          project_id: id,
          product_id: data?.product_id,
        })
        setRefresh(refresh + 1)
        setRefresh3(refresh3 + 1)
        setRefresh4(refresh4 + 1)
        setRefreshChart(refreshChart + 1)
      } else if (viewData?.id === 5) {
        const updateDepartment = await postCentralRequest({
          quantity: data?.central_quantity,
          description: data?.description,
          type: "centralrequest",
          project_id: id,
          product_id: data?.product_id,
        })
        setRefresh(refresh + 1)
        setRefresh2(refresh2 + 1)
        setRefresh4(refresh4 + 1)
        setRefreshChart(refreshChart + 1)
      } else if (viewData?.id === 7) {
        const requestManpower = await postRequestManpower({
          project_manpower_id: data?.project_manpower_id,
          from_date: !isEmpty(data)
            ? moment(data?.request_date[0]).format("YYYY-MM-DD")
            : "",
          to_date: !isEmpty(data)
            ? moment(data?.request_date[1]).format("YYYY-MM-DD")
            : "",
          designation_id: data?.designation_id,
          req_manpower_no: data?.req_manpower_no,
          req_remarks: data?.req_remarks,
          project_id: data?.project_id,
          exp_qty: data?.exp_qty,
        })
        setRefresh(refresh + 1)
        setRefresh4(refresh4 + 1)
        toastSuccess(requestManpower?.message)
      }
    } catch (err) {
      toastError(err?.message)
    } finally {
      toggle()
      setIsLoading(false)
    }
  }

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
    setMaterialData([])
  }

  const chartCard = [
    {
      name: "Requests",
      value: NumberFormat(
        Number(graphData?.total?.new) +
          Number(graphData?.total?.issued) +
          Number(graphData?.total?.rejected)
      ),
    },
    {
      name: "New",
      value: NumberFormat(Number(graphData?.total?.new)),
    },
    {
      name: "Issued",
      value: NumberFormat(Number(graphData?.total?.issued)),
    },
    {
      name: "Rejected",
      value: NumberFormat(Number(graphData?.total?.rejected)),
    },
  ]

  useEffect(() => {
    setSearch(watch1("search"))
    setPage(1)
  }, [watch1("search")])

  const handleAttendance = (i, val) => {
    console.log(`val`, val)
    const updatedRSelected = [...rSelected]
    updatedRSelected[i] = val
    setRSelected(updatedRSelected)
  }

  console.log(`dateSelected`, dateSelected, watch1("date"))

  const handleAttendanceAdd = async (i, item, chkState) => {
    console.log(
      `item`,
      item,
      // i,
      // chkState,
      // watch1(`attendance_new.${i}.employee_id`),
      dateSelected
    )
    const response = await postAttendance({
      ...(chkState == 2 && {
        id: item?.id,
      }),
      date: dateSelected,
      employee_id:
        chkState == 3
          ? employeeId
          : chkState == 2
          ? item?.employee_id?.id
          : watch1(`attendance.${i}.employee_id`)?.value,
      project_id: id,
      shift_id:
        chkState == 3
          ? watch1(`attendance_new.${i}.shift_id`)?.value
          : chkState == 2
          ? watch1(`attendance_update.${i}.shift_id`)?.value
          : watch1(`attendance.${i}.shift_id`)?.value,
      task_id:
        chkState == 3
          ? watch1(`attendance_new.${i}.task_id`)?.value
          : chkState == 2
          ? watch1(`attendance_update.${i}.task_id`)?.value
          : watch1(`attendance.${i}.task_id`)?.value,
      // start_time:
      //   rSelected[i] != 0
      //     ? moment(
      //         chkState == 2 && watch1(`attendance_update.${i}.start_time`)
      //           ? watch1(`attendance_update.${i}.start_time`)
      //           : chkState == 3
      //           ? watch1(`attendance_new.${i}.start_time`)
      //           : watch1(`attendance.${i}.start_time`)
      //       ).format("YYYY-MM-DD HH:mm:ss")
      //     : "",
      start_time:
        rSelected[i] != 0
          ? moment(
              /^\d{2}:\d{2}$/.test(
                chkState == 2 && watch1(`attendance_update.${i}.start_time`)
                  ? watch1(`attendance_update.${i}.start_time`)
                  : chkState == 3
                  ? watch1(`attendance_new.${i}.start_time`)
                  : watch1(`attendance.${i}.start_time`)
              )
                ? `${dateSelected} ${
                    chkState == 2 && watch1(`attendance_update.${i}.start_time`)
                      ? watch1(`attendance_update.${i}.start_time`)
                      : chkState == 3
                      ? watch1(`attendance_new.${i}.start_time`)
                      : watch1(`attendance.${i}.start_time`)
                  }`
                : chkState == 2 && watch1(`attendance_update.${i}.start_time`)
                ? watch1(`attendance_update.${i}.start_time`)
                : chkState == 3
                ? watch1(`attendance_new.${i}.start_time`)
                : watch1(`attendance.${i}.start_time`),
              /^\d{2}:\d{2}$/.test(
                chkState == 2 && watch1(`attendance_update.${i}.start_time`)
                  ? watch1(`attendance_update.${i}.start_time`)
                  : chkState == 3
                  ? watch1(`attendance_new.${i}.start_time`)
                  : watch1(`attendance.${i}.start_time`)
              )
                ? "YYYY-MM-DD HH:mm"
                : undefined
            ).format("YYYY-MM-DD HH:mm:ss")
          : "",

      // end_time:
      //   rSelected[i] != 0
      //     ? moment(
      //         chkState == 2 && watch1(`attendance_update.${i}.end_time`)
      //           ? watch1(`attendance_update.${i}.end_time`)
      //           : chkState == 3
      //           ? watch1(`attendance_new.${i}.end_time`)
      //           : watch1(`attendance.${i}.end_time`)
      //       ).format("YYYY-MM-DD HH:mm:ss")
      //     : "",
      end_time:
        rSelected[i] != 0
          ? moment(
              /^\d{2}:\d{2}$/.test(
                chkState == 2 && watch1(`attendance_update.${i}.end_time`)
                  ? watch1(`attendance_update.${i}.end_time`)
                  : chkState == 3
                  ? watch1(`attendance_new.${i}.end_time`)
                  : watch1(`attendance.${i}.end_time`)
              )
                ? `${dateSelected} ${
                    chkState == 2 && watch1(`attendance_update.${i}.end_time`)
                      ? watch1(`attendance_update.${i}.end_time`)
                      : chkState == 3
                      ? watch1(`attendance_new.${i}.end_time`)
                      : watch1(`attendance.${i}.end_time`)
                  }`
                : chkState == 2 && watch1(`attendance_update.${i}.end_time`)
                ? watch1(`attendance_update.${i}.end_time`)
                : chkState == 3
                ? watch1(`attendance_new.${i}.end_time`)
                : watch1(`attendance.${i}.end_time`),
              /^\d{2}:\d{2}$/.test(
                chkState == 2 && watch1(`attendance_update.${i}.end_time`)
                  ? watch1(`attendance_update.${i}.end_time`)
                  : chkState == 3
                  ? watch1(`attendance_new.${i}.end_time`)
                  : watch1(`attendance.${i}.end_time`)
              )
                ? "YYYY-MM-DD HH:mm"
                : undefined
            ).format("YYYY-MM-DD HH:mm:ss")
          : "",
      present: chkState == 3 ? 1 : rSelected[i] == 1 ? 1 : 0,
      overtime:
        chkState == 1
          ? watch1(`attendance.${i}.overtime`)
          : chkState == 2
          ? watch1(`attendance_update.${i}.overtime`)
          : watch1(`attendance_new.${i}.overtime`),
      leave_id:
        rSelected[i] == 0 ? watch1(`attendance.${i}.leave_id`)?.value : "",
      status: 1,
    })
    reset1()
    toastSuccess(response?.message)
    setRefreshAdd(refreshAdd + 1)
    attendanceRemove()
  }
  const handledate = e => {
    setDateStelected(moment(e[0]).format("YYYY-MM-DD"))
    console.log(`handledate`, e)
  }
  console.log(`watch1)`, dateSelected)

  const numberToWords = num => {
    const words = [
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
    ]
    return words[num] || num // Fallback to number if out of range
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Project Management"
              breadcrumbObject={[
                { title: "Project Management", link: "/project" },
                {
                  title: window.location.pathname
                    .toLowerCase()
                    .includes("project-attendance")
                    ? "Attendance"
                    : "Time Keeper",
                  link: `#`,
                },
              ]}
            />
          </div>
          <Card className="me-2 px-2 pb-2">
            <div className="mx-3 px-2 mt-4">
              <Row>
                <Col lg={12} className=" pe-2 ps-0">
                  <div className="tab-bg border-rds-round attendance-min-ht px-2 mb-4">
                    <div className="bold-heading  px-3">
                      <Nav tabs className="tab-active-bg">
                        <NavItem>
                          <NavLink
                            className={
                              activeTab === "1" ? "active pointer" : "pointer"
                            }
                            onClick={() => {
                              toggleTab("1")
                              setValue1("search", "")
                            }}
                          >
                            New
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={
                              activeTab === "2" ? "active pointer" : "pointer"
                            }
                            onClick={() => {
                              toggleTab("2")
                              setValue1("search", "")
                              // reset1({})
                            }}
                          >
                            Update
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <Row className="mt-2 mb-0">
                        <Col sm={4}>
                          <UFDate
                            control={control}
                            placeholder="Select Date"
                            name={"date_search"}
                            maxDate={moment().format("YYYY-MM-DD")}
                            onDateChange={e => handledate(e)}
                            className="ufinput-dashboard"
                          />
                        </Col>
                      </Row>
                      <Row className=" ever-rise-table dashboardTable ">
                        <Col xs={12}>
                          <TabContent activeTab={activeTab} className="pt-3">
                            <TabPane tabId="1">
                              {materialData && activeTab == "1" && (
                                <>
                                  <table className="estimation-table table-boxshadoe-none  mb-4">
                                    <thead>
                                      <tr>
                                        <th>Emp Id</th>
                                        <th>Designation</th>
                                        <th>Task</th>
                                        <th>Shift</th>
                                        <th className="wdt-10">IN Time</th>
                                        <th className="wdt-10">Out Time</th>
                                        <th className="me-2 wdt-7">
                                          OT Hours
                                        </th>
                                        <th className="me-2">Attendance</th>
                                        <th className="me-2">Leave Type</th>
                                        <th className="me-2">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {materialData?.data?.data?.map(
                                        (item, index) => (
                                          <tr key={`materialFields${index}`}>
                                            {/* <td>{item?.employee_code}</td> */}
                                            <td>
                                              {item?.designation?.name
                                                ? item?.designation?.name
                                                : "-"}
                                            </td>
                                            <td className="px-1">
                                              {/* <FormGroup className="mb-3"> */}
                                              <TasksList
                                                control={control}
                                                placeholder="Select"
                                                name={`attendance.${index}.task_id`}
                                                // invalid={!!errors1.parent_id}
                                                projectId={id}
                                              />
                                              {/* <FormFeedback invalid>
                                                {errors1.attendance.[index].task_id?.message}
                                              </FormFeedback> */}
                                              {/* </FormGroup> */}
                                            </td>
                                            <td>
                                              <ShiftsList
                                                control={control}
                                                placeholder="Select"
                                                name={`attendance.${index}.shift_id`}
                                              />
                                            </td>
                                            <td className="px-1">
                                              <UFTime
                                                control={control}
                                                name={`attendance.${index}.start_time`}
                                                className="time-input"
                                              />
                                            </td>
                                            <td className="px-1">
                                              <UFTime
                                                control={control}
                                                name={`attendance.${index}.end_time`}
                                                className="time-input"
                                              />
                                            </td>
                                            <td>
                                              <UFInput
                                                control={control}
                                                name={`attendance.${index}.overtime`}
                                                className="me-2"
                                                // ot={true}
                                              />
                                            </td>
                                            <td>
                                              <ButtonGroup className="me-2">
                                                <Button
                                                  color="primary"
                                                  outline
                                                  onClick={() =>
                                                    handleAttendance(index, 1)
                                                  }
                                                  active={
                                                    rSelected[index] === 1
                                                  }
                                                  className="attendance-button"
                                                >
                                                  P
                                                </Button>
                                                <Button
                                                  color="primary"
                                                  outline
                                                  onClick={() =>
                                                    handleAttendance(index, 0)
                                                  }
                                                  active={
                                                    rSelected[index] === 0
                                                  }
                                                  className="attendance-button"
                                                >
                                                  A
                                                </Button>
                                              </ButtonGroup>
                                            </td>
                                            <td className="px-1">
                                              {/* <FormGroup className=""> */}
                                              <LeaveType
                                                control={control}
                                                name={`attendance.${index}.leave_id`}
                                                invalid={!!errors1.leave_type}
                                                disabled={
                                                  rSelected[index] === 1
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {/* </FormGroup> */}
                                            </td>
                                            <td>
                                              <div
                                                className={
                                                  "me-4 btn btn-primary"
                                                }
                                                onClick={() =>
                                                  handleAttendanceAdd(
                                                    index,
                                                    item,
                                                    1
                                                  )
                                                }
                                              >
                                                Submit
                                              </div>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                      {attendanceFields?.map((item, index) => (
                                        <tr
                                          key={`attendance_${numberToWords(
                                            index
                                          )}`}
                                        >
                                          <td className="px-1">
                                            <FormGroup className="">
                                              <EmployeeList
                                                control={control}
                                                name={`attendance_new.${numberToWords(
                                                  index
                                                )}.employee_id`}
                                                placeholder={"Employee Code"}
                                                target={"body"}
                                                onSelectChange={e =>
                                                setEmployeeid(e?.id)
                                                }
                                              />
                                            </FormGroup>
                                          </td>
                                          <td>
                                            {watch1(
                                              `attendance_new.${numberToWords(
                                                index
                                              )}.employee_id`
                                            )?.label
                                              ? watch1(
                                                  `attendance_new.${numberToWords(
                                                    index
                                                  )}.employee_id`
                                                )?.designation?.name
                                              : "-"}
                                          </td>
                                          
                                          <td className="px-1">
                                            <FormGroup className="">
                                              <TasksList
                                                control={control}
                                                placeholder="Select"
                                                name={`attendance_new.${numberToWords(
                                                  index
                                                )}.task_id`}
                                                projectId={id}
                                              />
                                            </FormGroup>
                                          </td>
                                          <td className="px-1">
                                          <FormGroup className="">
                                            <ShiftsList
                                              control={control}
                                              placeholder="Select"
                                              name={`attendance_new.${index}.shift_id`}
                                            />
                                            </FormGroup>
                                          </td>
                                          <td className="px-1">
                                            <FormGroup className="">
                                              <UFTime
                                                control={control}
                                                name={`attendance_new.${numberToWords(
                                                  index
                                                )}.start_time`}
                                                className="time-input"
                                              />
                                            </FormGroup>
                                          </td>
                                          <td className="px-1">
                                            <FormGroup className="">
                                              <UFTime
                                                control={control}
                                                name={`attendance_new.${numberToWords(
                                                  index
                                                )}.end_time`}
                                                className="time-input"
                                              />
                                            </FormGroup>
                                          </td>
                                          <td>
                                            <FormGroup className="">
                                              <UFInput
                                                control={control}
                                                name={`attendance_new.${numberToWords(
                                                  index
                                                )}.overtime`}
                                                className="me-2"
                                                ot={false}
                                              />
                                            </FormGroup>
                                          </td>
                                          <td>
                                            {/* <ButtonGroup>
                                              <Button
                                                color="primary"
                                                outline
                                                onClick={() =>
                                                  handleAttendance(index, 1)
                                                }
                                                active={rSelected[index] === 1}
                                                className="attendance-button"
                                              >
                                                P
                                              </Button>
                                              <Button
                                                color="primary"
                                                outline
                                                onClick={() =>
                                                  handleAttendance(index, 0)
                                                }
                                                active={rSelected[index] === 0}
                                                className="attendance-button"
                                              >
                                                A
                                              </Button>
                                            </ButtonGroup> */}
                                          </td>
                                          <td></td>
                                          <td>
                                            <div
                                              className={"me-4 btn btn-primary"}
                                              onClick={() =>
                                                handleAttendanceAdd(
                                                  numberToWords(index),
                                                  item,
                                                  3
                                                )
                                              }
                                            >
                                              Submit
                                            </div>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <Row>
                                    <Col
                                      lg="12"
                                      xs={12}
                                      md={2}
                                      sm={12}
                                      className="d-flex justify-content-end"
                                    >
                                      {!attendanceFields.length ? (
                                        <Button
                                          color="primary"
                                          className="addButton mt-2"
                                          onClick={() =>
                                            attendanceAppend({
                                              employee_id: null,
                                              project_id: id,
                                              task_id: null,
                                              shift_id: null,
                                              start_time:
                                                moment().format(
                                                  "YYYY-MM-DD HH:mm"
                                                ),
                                              end_time:
                                                moment().format(
                                                  "YYYY-MM-DD HH:mm"
                                                ),
                                            })
                                          }
                                        >
                                          + Row
                                        </Button>
                                      ) : (
                                        ""
                                      )}
                                    </Col>
                                  </Row>
                                </>
                              )}
                            </TabPane>
                            <TabPane tabId="2">
                              {materialData && activeTab == "2" && (
                                <table className="estimation-table table-boxshadoe-none mb-4">
                                  <thead>
                                    <tr>
                                      <th>Emp Id</th>
                                      <th>Designation</th>
                                      <th className="wdt-17">Shift</th>
                                      <th className="wdt-10">IN Time</th>
                                      <th className="wdt-10">Out Time</th>
                                      <th className="me-2 wdt-10">OT Hours</th>
                                      <th>Attendance</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {materialData?.data?.data?.map(
                                      (item, index) => (
                                        <tr key={`materialFields${index}`}>
                                          <td>
                                            {item?.employee_id?.employee_code}
                                          </td>
                                          <td>
                                            {item?.employee_id?.designation
                                              ?.name
                                              ? item?.employee_id?.designation
                                                  ?.name
                                              : "-"}
                                          </td>
                                          <td>
                                            <ShiftsList
                                              control={control}
                                              placeholder="Select"
                                              name={`attendance_update.${index}.shift_id`}
                                            />
                                          </td>
                                          <td className="px-1">
                                            <UFTime
                                              control={control}
                                              name={`attendance_update.${index}.start_time`}
                                              className="time-input"
                                            />
                                          </td>
                                          <td className="px-1">
                                            <UFTime
                                              control={control}
                                              name={`attendance_update.${index}.end_time`}
                                              className="time-input"
                                            />
                                          </td>
                                          <td className="px-1">
                                            <UFInput
                                              control={control}
                                              name={`attendance_update.${index}.overtime`}
                                              className="me-2"
                                              ot={true}
                                            />
                                          </td>
                                          <td>
                                            <ButtonGroup>
                                              <Button
                                                color="primary"
                                                outline
                                                onClick={() =>
                                                  handleAttendance(index, 1)
                                                }
                                                active={rSelected[index] === 1}
                                                className="attendance-button"
                                              >
                                                P
                                              </Button>
                                              <Button
                                                color="primary"
                                                outline
                                                onClick={() =>
                                                  handleAttendance(index, 0)
                                                }
                                                active={rSelected[index] === 0}
                                                className="attendance-button"
                                              >
                                                A
                                              </Button>
                                            </ButtonGroup>
                                          </td>
                                          <td>
                                            <div
                                              className={"me-4 btn btn-primary"}
                                              onClick={() =>
                                                handleAttendanceAdd(
                                                  index,
                                                  item,
                                                  2
                                                )
                                              }
                                            >
                                              Update
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              )}
                            </TabPane>
                          </TabContent>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
          <Modal
            isOpen={modal}
            toggle={toggle}
            size={
              viewData?.id == 6
                ? "xl"
                : viewData?.id !== 4 && viewData?.id !== 5 && viewData?.id !== 7
                ? "lg"
                : "md"
            }
            unmountOnClose={false}
          >
            <>
              <ModalHeader className="custom-modal-header">
                <div className="d-flex justify-content-between">
                  <h5 className="ms-4">
                    {viewData?.id == 1
                      ? "Material Request"
                      : viewData?.id == 2
                      ? "Central Store Request"
                      : viewData?.id == 3
                      ? "Issue Note"
                      : viewData?.id == 4
                      ? "Store Issue Note"
                      : viewData?.id == 5
                      ? "Central Store Request"
                      : viewData?.id == 6
                      ? "Material Request"
                      : viewData?.id == 7
                      ? "Manpower Request"
                      : ""}
                  </h5>
                  <img
                    src={closeIcon}
                    alt=""
                    onClick={toggle}
                    width="10"
                    role="button"
                  />
                </div>
              </ModalHeader>
              <ModalBody>
                <FormProvider>
                  <Form
                    id={`ev-form`}
                    onSubmit={handleSubmit1(handleRegistration)}
                  >
                    {viewData?.id !== 4 &&
                      viewData?.id !== 5 &&
                      viewData?.id !== 6 &&
                      viewData?.id !== 7 && (
                        <Card className="me-2 px-2 pb-2">
                          <Row className="mt-2 ever-rise-table">
                            <Col xs={12}>
                              {materialRequestData?.data &&
                                viewData?.id == 1 && (
                                  <UpdateTable
                                    className="mt-5"
                                    nodes={materialRequestData?.data?.data}
                                    paginate={materialRequestData?.data}
                                    columns={materialRequestColumns}
                                    handlePagination={
                                      handleMaterialRequestPaginate
                                    }
                                    CurrentPage={materialPage}
                                    tableWidth="33% 33% 33%"
                                    mobileWidth="33% 33% 33%"
                                  />
                                )}
                              {csRequestData?.data && viewData?.id == 2 && (
                                <UpdateTable
                                  className="mt-5"
                                  nodes={csRequestData?.data?.data}
                                  paginate={csRequestData?.data}
                                  columns={csRequestColumns}
                                  CurrentPage={csRequestPage}
                                  handlePagination={handleCsRequestPaginate}
                                  tableWidth="25% 25% 25% 25%"
                                  mobileWidth="40% 40% 40% 40%"
                                />
                              )}
                              {issueNoteData?.data && viewData?.id == 3 && (
                                <>
                                  <UpdateTable
                                    className="mt-5"
                                    nodes={issueNoteData?.data?.data}
                                    paginate={issueNoteData?.data}
                                    columns={issueNoteColumns}
                                    CurrentPage={issueNotePage}
                                    handlePagination={handleissueNotePaginate}
                                    tableWidth="25% 25% 25% 25%"
                                    mobileWidth="40% 40% 40% 40%"
                                  />
                                </>
                              )}
                            </Col>
                          </Row>
                        </Card>
                      )}
                    {(viewData?.id === 4 ||
                      viewData?.id === 5 ||
                      viewData?.id === 7) && (
                      <>
                        <Row className="mt-2 ever-rise-table mx-2">
                          <Col xs={12}>
                            {viewData?.id == 4 && (
                              <>
                                <Row>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Project Store Availability
                                        <span className="mandatory">*</span>
                                      </Label>

                                      <UFInput
                                        control={control}
                                        placeholder="Enter the Customer Name"
                                        name={"project_store"}
                                        invalid={!!errors1.project_store}
                                        disabled={true}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.project_store?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Quantity
                                        <span className="mandatory">*</span>
                                      </Label>

                                      <UFInput
                                        control={control}
                                        placeholder="Enter the Quantity"
                                        name={"project_quantity"}
                                        invalid={!!errors1.project_quantity}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.project_quantity?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Issue Date
                                        <span className="mandatory">*</span>
                                      </Label>
                                      <UFDate
                                        control={control}
                                        name={"issue_date"}
                                        invalid={!!errors1.issue_date}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.issue_date?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Contact Person
                                        <span className="mandatory">*</span>
                                      </Label>

                                      <UsersList
                                        control={control}
                                        placeholder="Select Contact Person"
                                        name={"contact_person"}
                                        invalid={!!errors1.contact_person}
                                      />

                                      <FormFeedback invalid>
                                        {errors1.contact_person?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </>
                            )}
                            {viewData?.id == 5 && (
                              <>
                                <Row>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Central Store Availability
                                        <span className="mandatory">*</span>
                                      </Label>

                                      <UFInput
                                        control={control}
                                        placeholder=""
                                        name={"central_store"}
                                        invalid={!!errors1.central_store}
                                        disabled={true}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.central_store?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Quantity
                                        <span className="mandatory">*</span>
                                      </Label>

                                      <UFInput
                                        control={control}
                                        placeholder="Enter the Quantity"
                                        name={"central_quantity"}
                                        invalid={!!errors1.central_quantity}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.central_quantity?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Description
                                        <span className="mandatory">*</span>
                                      </Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Description"
                                        rows="5"
                                        name={"description"}
                                        invalid={!!errors1.description}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.description?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </>
                            )}
                            {viewData?.id == 7 && (
                              <>
                                <Row>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Category Code
                                        <span className="mandatory">*</span>
                                      </Label>
                                      <UFInput
                                        control={control}
                                        placeholder=""
                                        name={"category_code"}
                                        invalid={!!errors1.category_code}
                                        disabled={true}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.category_code?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Number of Hours
                                        <span className="mandatory">*</span>
                                      </Label>

                                      <UFInput
                                        control={control}
                                        placeholder="Enter Hour"
                                        name={"req_manpower_no"}
                                        invalid={!!errors1.req_manpower_no}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.req_manpower_no?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        From Date - To Date
                                        <span className="mandatory">*</span>
                                      </Label>
                                      <UFDate
                                        control={control}
                                        name={"request_date"}
                                        mode="range"
                                        minDate={moment().format("YYYY-MM-DD")}
                                        // onDateChange={e => handleRequestdate(e)}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.request_date?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>Minimum Manpower</Label>
                                      <UFInput
                                        control={control}
                                        placeholder="Expected Quantity"
                                        name={"exp_qty"}
                                        invalid={!!errors1.exp_qty}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.exp_qty?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>
                                        Remarks
                                        <span className="mandatory">*</span>
                                      </Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Description"
                                        rows="5"
                                        name={"req_remarks"}
                                        invalid={!!errors1.req_remarks}
                                      />
                                      <FormFeedback invalid>
                                        {errors1.req_remarks?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </Col>
                        </Row>
                      </>
                    )}
                    {(viewData?.id === 4 ||
                      viewData?.id === 5 ||
                      viewData?.id === 7) && (
                      <>
                        <hr />
                        <div className="pb-3 d-flex justify-content-end">
                          <LoadingButton
                            form={`ev-form`}
                            color={"primary"}
                            loading={isLoading}
                            disabled={isLoading}
                            className={"me-4"}
                            type="submit"
                          >
                            {viewData?.id === 4 ? "Issue Note" : "Request"}
                          </LoadingButton>
                        </div>
                      </>
                    )}
                  </Form>
                </FormProvider>
                {viewData?.id == 6 && (
                  <EditMaterialRequest
                    fromDashboard={true}
                    projectValue={{
                      value: id,
                      label: storeDashData?.data?.project_code,
                    }}
                    toggle={resetAfterCreatePo}
                  />
                )}
              </ModalBody>
            </>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TimeKeeper
